<script>
import StrWorker from "@/components/StrWorker.vue";

import {onMounted, ref} from "vue";
import useSharedData from "@/use/SharedData.js";
import useTools from "@/use/Tools.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useSharedSelectData from "@/use/SharedSelectData.js";
import useValidation from "@/use/Validation.js";
import {useValidationWorkFlowActionStore} from "@/stores/Request/ValidationWorkFlowAction.js";
import axios from "axios";

export default {
    components: {StrWorker},
    setup() {
        const {dialog, loading, inputColor, backgroundColor} = useSharedData();
        const {workFlowModules, validatorTypes} = useSharedSelectData();
        const {getBack} = useSharedMethod();
        const {$route} = useTools();
        const {mxRules} = useValidation();
        
        const actionStore = useValidationWorkFlowActionStore();
        
        
        const donnee = ref({
            workers: [],
            filter: {},
        });
        const validationWorkFlow = ref({});
        const modules = ref(null);
        const loadingAction = ref(false);
        const alreadySelected = ref([]);
        
        function findActionById(id) {
            loadingAction.value = true;
            axios.get(`/validationWorkFlowActions/${id}`).then(response => {
                let action = response.data;
                alreadySelected.value = action.workers;
                modules.value = action.modules;
                validationWorkFlow.value = {
                    id: action.validationWorkFlowId,
                    name: action.validationWorkFlowName,
                    steps: [],
                };
                action.steps.forEach(step => {
                    validationWorkFlow.value.steps.push({
                        id: step.stepId,
                        name: step.stepName,
                        validatorId: step.validatorId,
                        validatorType: step.validatorType,
                        serviceId: step.serviceId,
                        state: step.stepState,
                        x: step.stepX,
                    })
                })
            }).finally(() => {
                loadingAction.value = false;
            })
        }
        
        function save() {
            // if (this.$refs.form.validate()) {
            loading.value = true;
            const ids = donnee.value.workers.map((w) => {
                return w.id;
            });
            const body = {
                ids: ids,
                validationWorkFlow: validationWorkFlow.value,
                workFlowModules: modules.value,
                workFlowActionId: $route.params.actionId,
            };
            axios.put(`/workers/setValidationWorkFlow`, body, {
                params: donnee.value.filter,
            }).then(response => {
                if ($route.params.actionId) {
                    actionStore.updateAction(response.data);
                } else {
                    actionStore.addAction(response.data);
                }
                getBack();
            }).finally(() => {
                loading.value = false;
            });
            // }
        }
        
        onMounted(() => {
            if ($route.params.actionId) {
                findActionById($route.params.actionId);
            }
        });
        
        return {
            mxRules,
            donnee,
            dialog,
            loading,
            inputColor,
            backgroundColor,
            validationWorkFlow,
            workFlowModules,
            loadingAction,
            alreadySelected,
            modules,
            validatorTypes,
            save,
            getBack,
        }
    },
};
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="1800"
        scrollable
    >
        <v-card>
            <w-toolbar color="teal" :title="$t('module.validation_work_flow')"/>
            <v-divider/>
            <v-card-text>
                <str-worker
                    v-model="donnee"
                    :workflowId="validationWorkFlow.id"
                    :already-selected="alreadySelected"
                    :propertyKind="'WORKFLOW'"
                >
                    <v-row>
                        <v-container fluid>
                            <v-form ref="form" lazy-validation>
                                <v-row dense>
                                    <v-col cols="12">
                                        <w-label :label="$t('module.validation_work_flow')" required/>
                                        <str-work-flow-autocomplete
                                            v-model="validationWorkFlow"
                                            return-object
                                            :rules="[mxRules.isNotEmptyObject]"
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <w-label :label="$t('common.modules')" required/>
                                        <w-enum-select
                                            v-model="modules"
                                            multiple
                                            :items="workFlowModules"
                                            :rules="[mxRules.listRequired]"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row dense v-if="validationWorkFlow.id">
                                    <v-col cols="12">
                                        <w-fieldset :title="$t('common.actions')">
                                            <v-row dense>
                                                <v-col cols="3">
                                                    <strong>{{ $t('common.state') }}</strong>
                                                </v-col>
                                                <v-col cols="4">
                                                    <strong>{{ $t('common.validator_type') }}</strong>
                                                </v-col>
                                                <v-col cols="5">
                                                    <strong>{{ $t('common.validator') }}</strong>
                                                </v-col>
                                            </v-row>
                                            <v-row
                                                dense
                                                v-for="(step, index) in validationWorkFlow.steps"
                                                :key="index"
                                                v-show="step.state !== 'FINAL'"
                                            >
                                                <v-col cols="3">
                                                    <w-text-field
                                                        :value="step.name"
                                                        readonly
                                                   />
                                                </v-col>
                                                <v-col cols="4">
                                                    <w-enum-select
                                                        v-model="step.validatorType"
                                                        :items="validatorTypes"
                                                        :rules="[mxRules.required]"
                                                    />
                                                </v-col>
                                                <v-col cols="5">
                                                    <str-user-autocomplete
                                                        v-if="step.validatorType === 'SPECIFIC'"
                                                        v-model="step.validatorId"
                                                        :rules="[mxRules.required]"
                                                        validator
                                                    />
                                                    <organizational-chart-field
                                                        v-if="step.validatorType === 'SERVICE'"
                                                        v-model="step.serviceId"
                                                        :rules="[mxRules.required]"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </w-fieldset>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                    </v-row>
                </str-worker>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-apply
                    show
                    :loading="loading"
                    @press="save"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>